'use strict'

module.exports = normalize

function normalize(value) {
  return value.toLowerCase()
}



//////////////////
// WEBPACK FOOTER
// ./~/refractor/~/property-information/normalize.js
// module id = 281
// module chunks = 27180705640166